import { MultiBackendImpl } from './MultiBackendImpl';
export const MultiFactory = (manager, context, options) => {
  return new MultiBackendImpl(manager, context, options);
};